// extracted by mini-css-extract-plugin
export default {"calcContainer":"style_calcContainer__9t-V3"};